module.exports = __webpack_public_path__ + "img/func6.aa3882a2.png";